// Check if ONE value matches against validator.
export function oneOf(value: string, validList: string[]) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true;
    }
  }
  return false;
}

export function toUnderscore(value: string) {
  return value?.toLowerCase().replace(/ /g, '_');
}

export function getBaseDomain(req?: Record<string, unknown>) {
  const hostName = (req?.hostname || typeof window !== 'undefined' ? document.location?.hostname : undefined) as string;

  if (!hostName) {
    return undefined;
  }

  return `.${hostName.split('.').slice(-2).join('.')}`;
}

export function isUndefined(value: unknown) {
  return typeof value === 'undefined';
}

export function handleLocalStorage(token: string | null) {
  if (!window) {
    return;
  }

  if (!token) {
    localStorage.removeItem('dlfLoginToken');
  } else {
    localStorage.setItem('dlfLoginToken', token);
  }
}
